module.exports = __webpack_public_path__ + "static/media/eco.6a4e2dd5.webp";